module.exports = __webpack_public_path__ + "static/media/02-banner-03-perisur@2x.a4fbc325.jpg";